import { useQuery } from "@apollo/react-hooks";

export default (props) => {
  const { data, loading, error } = useQuery(props.query, {
    variables: props.variables,
  });

  return props.children({ error, loading, data: data || {} });
};
